import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PerformanceApiService {
  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getPerformance(type: 'GROUP' | 'CLASS' | 'COURSE' | 'DEPARTMENT', id: number, page?: number, search?: string) {
    if (!type) return null;

    let queryParams = new HttpParams();
    if (search) {
      queryParams = queryParams.set('search', search);
    }
    if (page) {
      queryParams = queryParams.set('page', page);
    }


    switch (type) {
      case 'GROUP':
        return this.http.get(`${this.apiUrl}group/${id}/insight`, { params: queryParams });
      case 'CLASS':
        return this.http.get(`${this.apiUrl}class/${id}/insight`, { params: queryParams });
      case 'COURSE':
        return this.http.get(`${this.apiUrl}course/${id}/insight`, { params: queryParams });
      case 'DEPARTMENT':
        return this.http.get(`${this.apiUrl}departments/${id}/insight`, { params: queryParams });
      // case 'STUDENT':
      //   return this.http.get(`${this.apiUrl}/performance/student/${id}/insight`);
      // case 'TEACHER':
      //   return this.http.get(`${this.apiUrl}/performance/teacher/${id}/insight`);
      // case 'HOD':
      //   return this.http.get(`${this.apiUrl}/performance/hod/${id}/insight`);
      // case 'STAFF':
      //   return this.http.get(`${this.apiUrl}/performance/staff/${id}/insight`);
      default:
        return null;
    }
  }

  removeStudentFromGroup(groupId: number, studentId: number) {
    return this.http.post(`${this.apiUrl}group/remove-students/${groupId}`, {
      student_ids: [studentId]
    });
  }
}
